<!--
 * @Description: 发言嘉宾
 * @Date: 2024-07-31 09:08:01
 * @LastEditTime: 2024-09-10 11:58:30
 * @LastEditors:  
-->
<template>
  <div class="main-container">
    <page-header>{{'CSGCT核心专家库' | dealLanguage('Speakers')}}</page-header>
    <div class="speakers">
      <speaker-item v-for="item in guestDtoList" :key="item.id" :itemDetail="item"></speaker-item>
    </div>
    <Spin v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="over-p" v-if="!more && !loading && guestDtoList.length">{{'已经到底了~' | dealLanguage('No more content to load.')}}</div>
    <div class="nodata" v-if="!loading && !guestDtoList.length">
      <p>当前页面暂无内容</p>
    </div>
    <div ref="indexlist-bottom"></div>
  </div>
</template>

<script>
import PageHeader from '@/components/pc/pageHeader.vue'
import { mapState } from 'vuex'
import SpeakerItem from '@/components/index/speakerItem.vue'
import { getActExhibitionAllGuest } from '@/service/vbef'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '发言嘉宾' : 'Previous Guests',
    }
  },
  data() {
    return {
      guestDtoList: [],
      loading: false,
      page: 1,
      more: true,
    }
  },
  components: {
    PageHeader,
    SpeakerItem,
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },
  created() {
    this.getActExhibitionAllGuest()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async getActExhibitionAllGuest() {
      this.loading = true
      let res = await getActExhibitionAllGuest({
        activityId: this.activityId,
        getCount: false,
        page: this.page,
        size: 20,
      })
      this.loading = false
      if (res.code == 0) {
        this.guestDtoList = [...this.guestDtoList, ...res.data.guestDtos]
        this.more = res.data.guestDtos.length == 20
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight

      const listbox = this.$refs['indexlist-bottom']
      const listrect = listbox.getBoundingClientRect()
      const listabsoluteTop = listrect.top + scrollTop

      if (
        scrollTop + windowHeight > listabsoluteTop &&
        scrollTop > 0 &&
        !this.loading &&
        this.more
      ) {
        this.handleMore()
      }
    },
    handleMore() {
      this.page++
      this.getActExhibitionAllGuest()
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
.main-container
  padding-bottom 40px
  >>> .ivu-spin
    background #fff
    margin-top 20px
  >>> .over-p
    margin-top 20px
    color #999999
    line-height 42px
    text-align center
  .nodata
    padding 30px 0
    text-align center
    font-size 0
    p
      font-size 14px
      color #666666
      line-height 22px
.speakers
  display flex
  flex-wrap wrap
  margin-top 30px
  >>> .speaker-item
    &:not(:nth-of-type(4n+1))
      margin-left 26px
    &:nth-of-type(n+5)
      margin-top 26px
</style>